<section id="crypto-currency-section" class="section-card-content" data-cy="deposit-crypto-screen">
  <form [formGroup]="cryptoCurrencyForm">
    <p class="details tw-text-[15px] tw-text-[#0F2950]" data-cy="deposit-crypto-details">
      Deposit from your Bitcoin or Bitcoin Cash wallets into your
      <a href="http://amwager.com/" class="tw-text-[#5495F7] tw-underline" data-cy="deposit-crypto-link">AmWager.com</a> account.
      Funds available after 6 block confirmations.
    </p>

    <p class="reminder tw-text-[16px] tw-text-[#3080EC] tw-mt-[13px] tw-mb-[28px]" data-cy="deposit-crypto-reminder">
      <span>*</span>Your IP Address and location will be recorded for fraud prevention purposes.
    </p>

    <div class="deposit-details tw-mb-[30px]">

      <div class="row">
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-funds-text">Funds Available</span>
        </div>
        <div class="column">
          <span class="tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-minutes-text">Within Minutes</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-fees-text">Fees</span>
        </div>
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-fees-number">2% + $0.25</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-min-text">Min. Deposit</span>
        </div>
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-min-number">$25</span>
        </div>
      </div>

      <div class="row">
        <div class="column">
          <span class="tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-max-text">Max. Deposit</span>
        </div>
        <div class="column">
          <span class="should-yellow tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-max-number">$10,000</span>
        </div>
      </div>

      <!-- <div>
        <span class="tw-text-[16px] tw-text-[#5D5D5D]">Funds Available</span>
        <span class="tw-text-[16px] tw-text-[#5D5D5D]">Fees</span>
        <span class="tw-text-[16px] tw-text-[#5D5D5D]">Min. Deposit</span>
        <span class="tw-text-[16px] tw-text-[#5D5D5D]">Max. Deposit</span>
      </div>
      <div>
        <span class="tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]">Within Minutes</span>
        <span class="tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]">2% + $0.25</span>
        <span class="tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]">$25</span>
        <span class="tw-font-bold tw-text-[16px] tw-text-[#5D5D5D]">$10,000</span>
      </div> -->

    </div>

    <div class="amount-row tw-relative">
      <!-- Message section -->
      <!-- tw-top-[-18px] -->
      <span class="tw-absolute tw-bottom-[-19px] tw-right-[0px] tw-h-[18px] tw-block tw-pt-[2px]">

        <!-- Required -->
        <span
          class="tw-block tw-text-right tw-text-xs tw-text-[#D83A19]"
          *ngIf="formVal['amount'] && formVal['amount']?.errors
            && (formVal['amount'].touched || formVal['amount'].dirty)"
          data-cy="deposit-crypto-amount-error"
        >
          {{
            formVal['amount']?.errors?.['min']
              ? 'Request below minimum of $25.'
              : formVal['amount']?.errors?.['max']
                ? 'Request above maximum of $10,000.'
                : 'Please enter valid amount.'
          }}
        </span>
      </span>

      <span class="amount-deposit-usd tw-block tw-text-[16px] tw-text-[#5D5D5D]" data-cy="deposit-crypto-input-label">
        Amount Deposit in USD
      </span>
      <input
        formControlName="amount"
        id="depositAmount"
        (keyup)="depositAmount()"
        type="number"
        min="25"
        max="10000"
        class="amount tw-h-[38px] tw-text-[22px] tw-text-[#645858]"
        placeholder="25"
        pattern="^\d+(\.\d{1,2})?$"
        amwager3DecimalInput
        data-cy="deposit-crypto-input"
      />
    </div>

    <button
      (click)="deposit()"
      [ngClass]="{'active': (amount && !isDepositing && formVal['amount'].valid)}"
      [disabled]="!amount || isDepositing || formVal['amount'].invalid"
      class="deposit-now tw-w-full tw-h-[41px] tw-text-[16px] tw-mt-[30px] tw-mb-[10px]"
      data-cy="deposit-crypto-button"
    >
      Deposit Now
    </button>

    <p class="notice tw-text-center tw-text-[16px] tw-text-[#3080EC]" data-cy="deposit-crypto-bottom-text">
      Deposit Funds direct to your App Account
    </p>
  </form>
</section>
